import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { Link } from '@inertiajs/vue3';
    import { CardTitle } from '@/components/ui/card';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CardMenuButton',
  props: {
    class: {},
    href: {},
    isActive: { type: Boolean }
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    "as-child": "",
    class: _normalizeClass(
            _unref(cn)(
                'flex h-7.5 items-center border-b-2 border-transparent opacity-50 transition-colors',
                _ctx.isActive && 'border-foreground opacity-100',
                props.class,
            )
        )
  }, [
    _createVNode(_unref(Link), { href: _ctx.href }, {
      default: _withCtx(() => [
        _createVNode(_unref(CardTitle), {
          class: _normalizeClass(_ctx.isActive ? 'font-bold' : 'font-normal')
        }, {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["href"])
  ], 2))
}
}

})